<template>
     <div v-if="!this.$store.state.general.user.verified">
      <plans msgtitle="You currently do not have access to Business Insights"
            msgdescription="Please choose a plan to pay to enjoy the Business Insights feature"
      ></plans>
    </div>
    <div v-else>

   
    <b-card no-body class="mb-0">
      <b-row class="p-2 pt-3 pb-3">
        <b-col cols :md=6>
          <h5>1. Select Project</h5>
          <b-form-select
            v-model="projectID"
            :options="projects"
            disabled-field="notEnabled"
            style="max-width: 300px;"
            size="lg"
            >
          </b-form-select>
        </b-col>
      </b-row>

      <b-tabs v-if="projectID" card nav-class="mt-1" class="tabs" v-model="tab">
        <b-tab :title="dashboard['title']" v-for="dashboard in dashboards" :key="dashboard.id">
          <template  v-slot:title>
            <div class="text-center px-3">
              <!-- <div class="h4 m-0 p-0">
                <count-to v-if="!!dashboard.report_ids && dashboard.report_ids.length > 0"
                  :start-val="0" :end-val="dashboard.report_ids.length" :duration="2000"/>
                <i v-else class="fa fa-spinner fa-spin"/>
              </div> -->
              <div>{{dashboard.title.toUpperCase()}}</div>
            </div>
          </template>
          <b-card-text v-if="!dashboard.report_ids">Coming Soon</b-card-text>
          <agents-reports v-if="!!dashboard.report_ids && dashboard.report_ids.length > 0" :dashboard="dashboard"></agents-reports>
        </b-tab>
        <b-tab v-if="dashboards.length == 0" title="New Dashboard">
          <template v-slot:title>
            <div class="text-center px-3">
              <div class="h4 m-0 p-0">
                <i class="fa fa-plus"></i>
              </div>
              <div>NEW DASHBOARD</div>
            </div>
          </template>
          <b-card-text>Coming Soon</b-card-text>
        </b-tab>
      </b-tabs>
    </b-card>
    </div>
</template>

<script>
  // import Insights from '@/components/Insights';
  import AgentsReports from '../components/CustomReportsManager/AgentsReports'
  import {saveActivity} from "@/utils";
  import Plans from './Plans/Plans'
  import VueSweetalert2 from 'vue-sweetalert2';
  import swal from 'sweetalert2';
  window.Swal = swal;

  export default {
    name: 'Dashboards',
    components: { AgentsReports, Plans },

    data() {
      const allDashboards = this.$store.state.files.dashboards;
      const allProjects = this.$store.state.files.projectList;
      const business_dashboards = [];
      // for (const dashboard of allDashboards) {
      //   if (dashboard["type"] === "business") {
      //     business_dashboards.push(dashboard)
      //   }
      // }
      return {
        tab: 0,
        projectID: null,
        allProjects: allProjects,
        allDashboards: allDashboards,
        project_: null,
        // dashboards: []
        // dashboards: business_dashboards
      };
    },

    watch:{
      tab(val) {
        saveActivity("Viewed " + this.dashboards[val]["title"] + " dashboard", "dashboard_view", false)
      }
    },

    computed: {
      projects() {
        var projects = [];
        this.$store.state.files.projectList.forEach(project => {
          var p = {'value': project.id, 'text': project.name};
          if (!projects.includes(p)) {
            projects.push(p);
          }
        });
        return projects;
      },

      dashboards() {
        var dashboards = [];
        var selectedProject = null;
        this.allDashboards.forEach(dashboard => {
          if (!!dashboard['project_id'] && dashboard['project_id'] === this.projectID && dashboard["type"] === "business") {
            dashboards.push(dashboard);
          }
        });
        return dashboards;
      }
    }
  };
</script>
